<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

        <span class="color-selector input" slot="input">
            <span>
                <!-- Add dropdown -->
                <app-dropdown>
                    <app-dropdown-trigger slot-scope="{toggle}" :handle-click="toggle" :toggle="false">
                        <div class="color-box" v-bind:style="{'background-color': content}"></div>
                    </app-dropdown-trigger>

                    <app-dropdown-menu slot="menu" width="200" direction="ltr" slot-scope="{toggle}">
                        <ul class="list-reset" style="padding: 3px;">
                            <li v-for="colour in colours" style="display: inline-block;">
                                <span @click="change(colour); toggle()" style="display: block; width: 28px; height: 28px; border: 1px solid #eee; border-radius: 3px; margin: 2px;" v-bind:style="{'background-color': colour}"></span>
                            </li>
                        </ul>
                    </app-dropdown-menu>
                </app-dropdown>
            </span>
            <span>
                <input
                    type="text"
                    ref="handle"
                    :value="value"
                    :class="options"
                    @input="update()"
                    v-bind="$attrs"
                />
            </span>
        </span>
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    import Dropdown from '@/components/Dropdown';
    import DropdownTrigger from '@/components/DropdownTrigger';
    import DropdownMenu from '@/components/DropdownMenu';

    export default {
        name: 'app-field-text',
        components: {
            'app-field': Field,
            'app-label': Label,
            'app-dropdown': Dropdown,
            'app-dropdown-menu': DropdownMenu,
            'app-dropdown-trigger': DropdownTrigger
        },
        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            }
        },
        data: () => ({
            content: '',
            colours: ['#f1f5f9', '#64748B','#F8FAFC','#475569','#0F172A','#FFD300','#0071BA']
        }),
        mounted() {
            if (this.value) {
                this.content = this.value;
            }
        },
        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },
        methods: {
            update() {
                this.$emit('input', this.content);
            },
            change(val) {
                this.content = val;

                this.update();
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';

    .color-selector {
        @apply .flex .items-center .w-full;

        padding: 0 !important;
    }

    .color-selector .color-box {
        height: 26px;
        width: 26px;
        cursor: pointer;
        border: 1px solid #eee;
        -webkit-border-radius: 3px;
        border-radius: 3px;
        margin-left: 3px;
    }

    .color-selector > span {
        @apply .flex-grow;
    }

    .color-selector input[type="text"] {
        @apply .rounded .w-full .p-0 .m-0 .px-2;

        font-size: .875rem;
        color: #3d4852;
        border: 0;
        height: 32px;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
    }
</style>



// WEBPACK FOOTER //
// src/components/fields/inputs/Colour.vue